// Importar as funções necessárias do SDK do Firebase
import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, setDoc } from "firebase/firestore";

// Configuração do Firebase para o projeto
const firebaseConfig = {
  apiKey: "AIzaSyAGhU1U7zWFFZQNQHx3zDtfEeE4M0HMs8Q",
  authDomain: "unitymoz-draiva.firebaseapp.com",
  projectId: "unitymoz-draiva",
  storageBucket: "unitymoz-draiva.firebasestorage.app",
  messagingSenderId: "827846979757",
  appId: "1:827846979757:web:25e90c2f69935b6efe1624",
};

// Inicializa o Firebase apenas uma vez
const app = initializeApp(firebaseConfig);

// Instâncias de serviços do Firebase
export const auth = getAuth(app);
export const db = getFirestore(app);

/**
 * Registra um novo usuário no Firestore na coleção "users".
 * @param {Object} user - Objeto do usuário autenticado do Firebase.
 */
export const registerUserInFirestore = async (user) => {
  if (!user || !user.uid) {
    console.error("Usuário inválido para registro no Firestore.");
    return;
  }

  const userRef = doc(db, "users", user.uid);

  try {
    await setDoc(
      userRef,
      {
        email: user.email,
        createdAt: new Date().toISOString(),
        tests: [], // Inicializa com um array vazio de testes
      },
      { merge: true } // Garante que dados existentes não sejam sobrescritos
    );
    console.log("✅ Usuário registrado no Firestore com sucesso!");
  } catch (error) {
    console.error("🔥 Erro ao registrar usuário no Firestore:", error.message);
  }
};

// Monitorar mudanças no estado de autenticação
onAuthStateChanged(auth, (user) => {
  if (user) {
    console.log("👤 Usuário autenticado:", user.email);
    registerUserInFirestore(user); // Registra o usuário no Firestore
  } else {
    console.log("👤 Nenhum usuário autenticado.");
  }
});

const testFirestoreConnection = async () => {
  try {
    const testRef = doc(db, "testResults", "test_connection");
    await setDoc(testRef, { message: "Conexão com Firestore bem-sucedida!", timestamp: new Date() });
    console.log("✅ Firestore está funcionando corretamente!");
  } catch (error) {
    console.error("❌ Erro ao conectar com Firestore:", error);
  }
};

testFirestoreConnection();
